import React from "react";
import styles from "./MatrixQuestionTable.module.scss";

export interface MatrixQuestionRow {
  key: string;
  /** Satır başındaki numara (anketteki genel soru numarası). */
  number: number;
  label: string;
  required?: boolean;
  /** Seçili sütunun index'i; seçim yoksa null. */
  selectedIndex: number | null;
}

interface MatrixQuestionTableProps {
  title?: string;
  columns: string[];
  rows: MatrixQuestionRow[];
  onSelect?: (rowKey: string, columnIndex: number) => void;
  readOnly?: boolean;
}

/**
 * Kağıt değerlendirme formlarındaki gibi tablo soru: her satır bir madde,
 * her sütun ortak bir seçenek (İyi / Orta / İyi Değil, Evet / Hayır).
 */
const MatrixQuestionTable: React.FC<MatrixQuestionTableProps> = ({
  title,
  columns,
  rows,
  onSelect,
  readOnly = false,
}) => (
  <div className={styles.wrapper}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.titleCell} colSpan={2}>
            {title}
          </th>
          {columns.map((col, i) => (
            <th key={i} className={styles.columnCell}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.key} data-question-index={row.number}>
            <td className={styles.numberCell}>{row.number}</td>
            <td className={styles.labelCell}>
              {row.label}
              {row.required && <span className={styles.required}>*</span>}
            </td>
            {columns.map((col, i) => (
              <td key={i} className={styles.radioCell}>
                <input
                  type="radio"
                  name={`matrix-${row.key}`}
                  aria-label={`${row.label} – ${col}`}
                  checked={row.selectedIndex === i}
                  disabled={readOnly}
                  onChange={() => onSelect?.(row.key, i)}
                />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default MatrixQuestionTable;
